module.exports = __webpack_public_path__ + "img/doc-heart-hands-purple.3470fb44.png";